import { fetchConToken } from "../helpers/fetch";

const CosegurosService = {
  getBuscardorPracticasCoseguroTexto: (texto) => {
    return fetchConToken(`RelEfectorCodNom/traerPorTexto?texto=${texto}`);
  },
  getBuscardorPracticasAutorizacionTexto: (parametroCod, internacionDomiciliaria, integracion = false, esPresupuesto = false) => {
    if (esPresupuesto) {
      return fetchConToken(
        `NomencladorNacional?codigoNombre=${parametroCod}&todas=${true}`
      );
    } else {
      return fetchConToken(
        `NomencladorNacional?codigoNombre=${
          parametroCod
        }&internacionDomiciliaria=${
          internacionDomiciliaria
        }&integracion=${integracion}`
      );
    }
  },
  getPracticaLiquidaciones: (texto, esLineaCodigoLiq, idEfectorFacturacion, idTipoNomenclador) => {
    return fetchConToken(
      `NomencladorNacional/traerLiquidaciones?texto=${
        texto
      }&esCodLiq=${
        esLineaCodigoLiq
      }&idEfectorFacturacion=${
        idEfectorFacturacion
      }&idTipoNomenclador=${
        idTipoNomenclador
      }`
    );
  },
  getPracticas: (data) => {
    return fetchConToken(
      `RelEfectorCodNom/traerPorParametros?idEspecialidad=${
        data.idEspecialidad
      }&idCentroMedico=${data.idCentroMedico}&idProfesional=${
        data.idProfesional
      }${!!data.idAgenda ? `&idAgenda=${data.idAgenda}` : ""}`
    );
  },
  getPracticasExterno: (data) => {
    return fetchConToken(
      `RelEfectorCodNom/traerPorParametrosExternos?idEspecialidad=${
        data.idEspecialidad
      }&idCentroMedico=${data.idCentroMedico}&idProfesional=${
        data.idProfesional
      }&idObraSocial=${data.idObraSocial}`
    );
  },
  getPracticasLaboDemanda: (idAgenda) => {
    return fetchConToken(`RelCodNomCentroEfector/traerPrecargadasPorIdAgenda/${idAgenda}`);
  },
  addPractica: (data) => {
    return fetchConToken(`RelEfectorCodNom`, data, "POST");
  },
  postPracticas: (data) => {
    return fetchConToken(`TurnoPractica`, data, "POST");
  },
  getValorizaciones: (idAgenda) => {
    return fetchConToken(`TurnoPractica/traerValorizacion/${idAgenda}`);
  },
  getValorizacionesCtaCte: (idAgenda) => {
    return fetchConToken(`TurnoPractica/traerValorizacionCtaCte/${idAgenda}`);
  },
  getValorizacionesCtaCteExterno: (idAgenda, idObraSocial) => {
    return fetchConToken(`TurnoPractica/traerValorizacionCtaCteExterno?idAgenda=${idAgenda}&idObraSocial=${idObraSocial}`);
  },
  postTurnoImporte: (data) => {
    return fetchConToken(`TurnoImporte`, data, "POST");
  },
  postFacturaTurno: (data) => {
    return fetchConToken(`TurnosFacturas`, data, "POST");
  },
  postExentarTurno: (data) => {
    return fetchConToken(`TurnoExencion`, data, "POST");
  },
  getHabilitarDevolucionMonto: (idAgenda) => {
    return fetchConToken(
      `TurnosFacturas/comprobarAduedaComprobante/${idAgenda}`
    );
  },
  postAnularComprobantePorCancelacion: (data) => {
    return fetchConToken(
      `TurnosFacturas/anularComprobantePorCancelacion`,
      data,
      "POST"
    );
  },
};

export { CosegurosService as default };
